import React from 'react';
import Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
import HighchartsReact from 'highcharts-react-official';
import { capitalizeFirstLetterOfEachWord } from '../Utils/utils';

if (typeof Highcharts3D === 'function') {
  Highcharts3D(Highcharts);
}

const StudiesChart = ({ categories, series }) => {
  const options = {
    chart: {
      type: 'column',
      options3d: {
        enabled: true,
        alpha: 10,
        beta: 15,
        depth: 50,
        viewDistance: 25,
      },
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      categories,
      labels: {
        style: {
          color: '#ffffff',
          fontSize: '14px',
        },
        formatter: function () {
          const fullName = this.value;
          const truncatedName = fullName.length > 8 ? fullName.slice(0, 8) + '...' : fullName;
          return `<span title="${fullName}">${capitalizeFirstLetterOfEachWord(truncatedName)}</span>`;
        },
      },
    },
    yAxis: {
      title: {
        text: 'Number of Studies',
        style: {
          color: '#ffffff',
          fontSize: '14px',
        },
        x: -32,
      },
      labels: {
        style: {
          color: '#ffffff',
        },
      },
      tickInterval: 100,
    },
    plotOptions: {
      column: {
        depth: 25,
        colorByPoint: true,
      },
    },
    series,
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default StudiesChart;
